interface LinkIconProps {
	className?: string
}

export default function LinkIcon({className}:LinkIconProps) {
	return (
		<svg className={className} viewBox="0 0 16 17" xmlns="http://www.w3.org/2000/svg"><path d="M15.9161 0.503027C12.6133 1.49349 8.93143 1.9013 5.6195 1.65132C5.55349 1.64642 5.5231 1.7317 5.57735 1.76994C8.34878 3.72667 10.4925 4.29396 11.4421 4.45734L0.0191167 15.8798C-0.00637224 15.9053 -0.00637224 15.9468 0.0191167 15.9723L0.527589 16.4807C0.553078 16.5062 0.594579 16.5062 0.620068 16.4807L12.0427 5.05829C12.2061 6.0079 12.7734 8.15122 14.7302 10.9229C14.7684 10.9769 14.8537 10.9468 14.8488 10.8808C14.5988 7.56891 15.0066 3.88712 15.9971 0.584394C16.0121 0.53407 15.9661 0.487995 15.9161 0.503027Z" fill="currentColor"/></svg>
	)
}